export const daysArray = Array.from({ length: 7 }, (_, index) => index + 1)
